import _ from "lodash"
import React, { useState } from "react"
import { MultiRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { DropdownInput, NamedItemInput, NumberInput, TextInput } from "components/table/carousel/inputs"
import RowAddRemove from "components/table/carousel/row-add-remove"
import { field_attrs } from "components/table/lib/column-field"
import increaseService from "data/increase"

type Item_t = object & {
  i: number
}

const RecoveriesAmt = (props: {rowData: [], field: string, defaults: {}, namedItems:object, persist: Function}) => {
  const initialItems = _.get(props.rowData[props.field], "amtItems")
  const isMarketLease = window.location.pathname.includes("/market-lease");

  const emptyItem = {
    amt: null,
    amtType: props.defaults['recoveryAmtAmtType'],
    increaseNamedItemId: _.get(props, 'defaults.recoveryAmtIncrease.increaseNamedItemId', _.find(increaseService.value(), {code: '*None'})?.increaseid),
    name: null
  }
  if (isMarketLease) emptyItem['inflationNamedItemId'] = null

  const [items, setItems] = useState<Item_t[]>(initialItems ? _.sortBy(initialItems.map((item, i) => { return {...item, i }})) : [{...emptyItem, i:0}])

  function updateData(val:any, field:string[]):void {
    let nextItems = _.cloneDeep(items);
    if (field[1] === 'name' && nextItems[field[0]][field[1]] === null && val === '') return
    nextItems[field[0]][field[1]] = val
    setItems(nextItems)
    nextItems = nextItems.map(({i, ...rest}) => rest)
    let nextData = _.cloneDeep(props.rowData[props.field])
        nextData = {...nextData, 'amtItems': nextItems}
    props.persist(nextData, props.field, props.rowData)
  }

  function updateItems(updatedItems:Item_t[]):void {
    let nextData = _.cloneDeep(props.rowData[props.field])
    let nextItems = updatedItems.map((item, i) => { return {...item}})
    setItems(nextItems)
    const strippedItems = nextItems.map(({i, ...rest}) => rest)
    if (updatedItems.length === 1 && items.length === 1) delete nextData['amtItems']
    else _.set(nextData, "amtItems", strippedItems)
    props.persist(nextData, props.field, props.rowData)
  }

  let renderItems = _.sortBy(items, 'i')
  const item_attrs = (field) => field_attrs(isMarketLease ? 'marketlease' : 'rentroll', `${props.field}.amtItems`)(field)(props.rowData, props)

  const params = {
    attrs: item_attrs,
    data: items,
    persist: updateData
  }

  const reportTagOptions = props.namedItems?.['reportTags']?.map(tag => {
    if (tag.code) return {label: tag.code, value: tag.reporttagid}
  })

  return (
    <div>
      { renderItems.map((row:object, i) => (
          <MultiRowCarouselState_s className="carousel-multi-row recoveries">
            <div>
              { i === 0 && <label>Name</label> }
              <TextInput
                className="automated"
                field={[row['i'], 'name']}
                {...params}
              />
            </div>
            <div>
              { i === 0 && <label>Amt</label> }
              <NumberInput
                className="automated billion-input"
                field={[row['i'], 'amt']}
                readPrecision={4}
                writePrecision={4}
                {...params}
              />
            </div>
            <div>
              { i === 0 && <label>Amt Type</label> }
              <DropdownInput
                className="automated"
                field={[row['i'], 'amtType']}
                options={['/Mo', '/Yr', '/Area/Mo', '/Area/Yr']}
                default="/Area/Yr"
                {...params}
              />
            </div>
            { isMarketLease && <div>
            { i === 0 && <label>Inflation</label> }
              <NamedItemInput
                className="automated"
                field={[row['i'], 'inflationNamedItemId']}
                options={props.namedItems['inflation']}
                {...params}
              />
            </div> }
            <div>
            { i === 0 && <label>Increase</label> }
              <NamedItemInput
                className="automated"
                field={[row['i'], 'increaseNamedItemId']}
                options={props.namedItems['increase']}
                {...params}
              />
            </div>
            <div>
            { i === 0 && <label>Report Tag</label> }
              <DropdownInput
                className="automated"
                field={[row['i'], 'reportTagNamedItemId']}
                options={reportTagOptions}
                onClear={() => updateData(null, [row['i'], 'reportTagNamedItemId'])}
                {...params}
              />
            </div>
            <RowAddRemove emptyRecord={emptyItem} setState={updateItems} row={i} items={renderItems} />
          </MultiRowCarouselState_s>
      ))}
    </div>
  )
}

export default RecoveriesAmt
